var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteBottomArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.705503 0.294621C1.09478 -0.0946516 1.72581 -0.0949955 2.1155 0.293852L8.00012 6.17001L13.8847 0.293853C14.2744 -0.0949953 14.9055 -0.0946514 15.2947 0.294621C15.6843 0.684194 15.6843 1.31582 15.2947 1.70539L8.70723 8.2929C8.3167 8.68342 7.68354 8.68342 7.29301 8.2929L0.705503 1.70539C0.31593 1.31582 0.31593 0.684194 0.705503 0.294621Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.705503 0.294621C1.09478 -0.0946516 1.72581 -0.0949955 2.1155 0.293852L8.00012 6.17001L13.8847 0.293853C14.2744 -0.0949953 14.9055 -0.0946514 15.2947 0.294621C15.6843 0.684194 15.6843 1.31582 15.2947 1.70539L8.70723 8.2929C8.3167 8.68342 7.68354 8.68342 7.29301 8.2929L0.705503 1.70539C0.31593 1.31582 0.31593 0.684194 0.705503 0.294621Z",
    fill: "url(#paint0_linear_6163_51660)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6163_51660",
    x1: 0.413324,
    y1: 0.00244118,
    x2: 8.51736,
    y2: 12.9953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.02
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteBottomArrow);
export default __webpack_public_path__ + "static/media/white_bottom_arrow.90f9c661.svg";
export { ForwardRef as ReactComponent };